import React, { Component, Fragment, createRef } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import Form from "../../../common/form/Form/Form"; // Form
import isEmpty from "assets/scripts/utils/isEmpty";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import TextAreaFormGroup from "assets/scripts/components/common/form/TextAreaFormGroup/TextAreaFormGroup";
import PhoneFormGroup from "assets/scripts/components/common/form/PhoneFormGroup/PhoneFormGroup";
import validPhone from "assets/scripts/utils/validPhone";
import { ERRORS, REQUIRED } from "assets/scripts/constants/FormMessages";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import getMaxLengthError from "assets/scripts/utils/getMaxLengthError";
import AddDocumentModal from "assets/scripts/components/containers/secure/Documents/AddDocumentModal/AddDocumentModal";
import uid from "assets/scripts/utils/uid";
import ApiMessage from "assets/scripts/components/presentational/ApiMessage/ApiMessage";
import { ASYNC_STATE } from "assets/scripts/constants/Constants";
import Captcha from "../../../common/form/Captcha/Captcha";
const messages = defineMessages({
    submit: {
        id: "forms.contactPublic.submit",
        defaultMessage: "Send"
    },
    nameLabel: {
        id: "forms.contactPublic.name.label",
        defaultMessage: "Name"
    },
    phoneLabel: {
        id: "forms.contactPublic.phone.label",
        defaultMessage: "Phone number"
    },
    phoneHelp: {
        id: "forms.contactPublic.phone.help",
        defaultMessage: "Example: 123-456-7890"
    },
    subjectLabel: {
        id: "forms.contactPublic.phone.subject",
        defaultMessage: "Subject"
    },
    messageLabel: {
        id: "forms.contactPublic.message.subject",
        defaultMessage: "Message"
    },
    referenceNumberLabel: {
        id: "forms.contactPublic.referenceNumber.label",
        defaultMessage: "Reference Number"
    },
    type: {
        id: "forms.contactPublic.header.type",
        defaultMessage: "Type"
    },
    name: {
        id: "forms.contactPublic.header.name",
        defaultMessage: "Name"
    },
    attachedDocuments: {
        id: "forms.contactPublic.attachedDocuments",
        defaultMessage: "Attached Documents"
    }
});
function getErrors(value) {
    return {
        name: isEmpty(value.name) ? REQUIRED : getMaxLengthError(value.name, 100),
        phone: validPhone(value.phone) ? null : ERRORS.PHONE,
        subject: isEmpty(value.subject) ? REQUIRED : getMaxLengthError(value.subject, 100),
        message: isEmpty(value.message) ? REQUIRED : null,
        referenceNumber: getMaxLengthError(value.referenceNumber, 50)
    };
}
export default class ContactPublicForm extends Component {
    constructor() {
        super(...arguments);
        this._uid = uid();
        this._captcha = createRef();
        this.state = {
            addOpen: false,
            value: {
                name: "",
                phone: "",
                subject: "",
                message: "",
                referenceNumber: this.props.refNumber
                    ? this.props.refNumber.toString()
                    : "",
                documents: [],
                captchaResponse: null
            }
        };
        this._renderButtons = ({ renderSubmitButton }) => {
            return (<Fragment>
				<button type="button" className="btn mix-btn_fixedWidth btn-progressive js-modal-btnTrigger pull-right" style={{ marginBottom: "5px" }} onClick={() => this.setState({ addOpen: true })} data-modaltriggerid={this._uid} disabled={this.props.isLoading}>
					<FormattedMessage id="documents.upload.button" defaultMessage="Attach Document"/>
				</button>
				{renderSubmitButton()}
			</Fragment>);
        };
        this._handleSubmit = () => {
            if (this._captcha.current != null) {
                this._captcha.current.reset();
            }
            this.props.sendToAPI(this.state.value);
        };
        this._handleNameChange = (name) => this._updateValue({ name });
        this._handlePhoneChange = (phone) => this._updateValue({ phone });
        this._handleSubjectChange = (subject) => this._updateValue({ subject });
        this._handleMessageChange = (message) => this._updateValue({ message });
        this._handleReferenceNumberChange = (referenceNumber) => this._updateValue({ referenceNumber });
    }
    render() {
        const { props, state } = this;
        const { value } = state;
        const errors = getErrors(value);
        const isValid = Object.values(errors).every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        return (<Fragment>
				<AddDocumentModal withoutAccounts open={state.addOpen} backendErrors={{ backendErrors: {}, globalError: null }} documentTypes={props.documentTypes || []} triggerId={this._uid} state={props.documentTypes === null ? ASYNC_STATE.PENDING : ASYNC_STATE.NONE} error={null} locale={props.locale} onClose={() => this.setState({ addOpen: false })} onUpload={doc => this.setState(s => ({
            addOpen: false,
            value: {
                ...s.value,
                documents: [
                    ...s.value.documents,
                    doc
                ]
            }
        }))}/>

				<Form isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError} renderButtons={this._renderButtons} submitDisabled={props.captchaRequired && value.captchaResponse == null}>
					<fieldset className="fieldset">
						<legend>
							<span className="u-isVisuallyHidden">
								<FormattedMessage id="forms.contactPublic.legend" defaultMessage="Contact Information"/>
							</span>
						</legend>
						<TextFormGroup name="name" label={messages.nameLabel} value={value.name} onChange={this._handleNameChange} error={errors.name} backendError={backendErrors.name} required inputProps={{
            autoComplete: "name"
        }}/>
						<PhoneFormGroup name="phone" label={messages.phoneLabel} value={value.phone} onChange={this._handlePhoneChange} error={errors.phone} backendError={backendErrors.phone} help={messages.phoneHelp} inputProps={{
            autoComplete: "tel"
        }}/>
						<TextFormGroup type="number" name="referenceNumber" label={messages.referenceNumberLabel} value={value.referenceNumber} onChange={this._handleReferenceNumberChange} error={errors.referenceNumber} backendError={backendErrors.referenceNumber}/>
						<TextFormGroup name="subject" label={messages.subjectLabel} value={value.subject} onChange={this._handleSubjectChange} error={errors.subject} backendError={backendErrors.subject} required/>
						<TextAreaFormGroup name="message" label={messages.messageLabel} value={value.message} onChange={this._handleMessageChange} error={errors.message} backendError={backendErrors.message} required/>

						<Captcha ref={this._captcha} onChange={captchaResponse => this._updateValue({ captchaResponse })} required={props.captchaRequired}/>

						{!!state.value.documents.length && (<Fragment>
								<h2 className="hdg" style={{ fontSize: "1.25rem" }}>
									<FormattedMessage {...messages.attachedDocuments}/>
								</h2>
								<div className="tableList" style={{ wordBreak: "break-word" }}>
									<div className="tableListRow">
										<ol className="tableListRow-list">
											<li className="tableListRow-list-col tableListRow-list-col_m mix-tableListRow-list-col_hdg">
												<FormattedMessage {...messages.type}/>
											</li>
											<li className="tableListRow-list-col tableListRow-list-col_l mix-tableListRow-list-col_hdg">
												<FormattedMessage {...messages.name}/>
											</li>
											<li className="tableListRow-list-col tableListRow-list-col_s mix-tableListRow-list-col_hdg"/>
										</ol>
									</div>
									<ol>
										{state.value.documents.map((document, index) => (<li className="tableListRow" key={index}>
												<ol className="tableListRow-list">
													<li className="tableListRow-list-col tableListRow-list-col_m">
														<ApiMessage value={props.documentTypes.filter(it => it.id === document.documentTypeId)[0].name} valueES={props.documentTypes.filter(it => it.id === document.documentTypeId)[0].nameES}/>
													</li>
													<li className="tableListRow-list-col tableListRow-list-col_l">
														{document.fileName}
													</li>
													<li className="tableListRow-list-col tableListRow-list-col_s">
														<button type="button" style={{
            height: "100%",
            margin: "auto",
            display: "block"
        }} onClick={() => this.setState(s => ({
            value: {
                ...s.value,
                documents: s.value.documents.filter(d => d.fileName !== document.fileName)
            }
        }))}>
															<i className="fa fa-times"/>
														</button>
													</li>
												</ol>
											</li>))}
									</ol>
								</div>
							</Fragment>)}
					</fieldset>
				</Form>
			</Fragment>);
    }
    _updateValue(value) {
        this.setState(prevState => ({
            value: {
                ...prevState.value,
                ...value
            }
        }));
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/ContactForm/ContactForm.tsx